const PRICE_PATTERN = /((?:US)?\$\s*)([\d,]+(?:\.\d{2})?)/;

/** @returns {number} delivery charge in cents that Redo's total is missing */
function pendingDeliveryCents() {
  const footer = document.querySelector('#cart-drawer .cart-footer');
  if (!footer) return 0;
  if (footer.dataset.deliveryFree === 'true') return 0;
  return parseInt(footer.dataset.deliveryCents, 10) || 0;
}

function formatAmount(cents, sample) {
  const amount = (cents / 100).toFixed(2);
  /* Match the grouping style Redo already used ("1,234.50" vs "1234.50"). */
  if (!sample.includes(',')) return amount;
  return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * Rewrites one price string, adding `addCents` to whatever amount it contains.
 * @returns {string|null} the new string, or null if there was nothing to change
 */
function withDeliveryAdded(text, addCents) {
  if (!text) return null;
  const match = text.match(PRICE_PATTERN);
  if (!match) return null;

  const original = match[2];
  const baseCents = Math.round(parseFloat(original.replace(/,/g, '')) * 100);
  if (!Number.isFinite(baseCents)) return null;

  const next = formatAmount(baseCents + addCents, original);
  return text.replace(PRICE_PATTERN, `$1${next}`);
}

const applied = new WeakMap();

function patchToggle(toggle) {
  const root = toggle.shadowRoot;
  if (!root) return;

  const addCents = pendingDeliveryCents();
  if (addCents === 0) return;

  const headline = root.querySelector('[data-target="headline-text-container"] p');
  if (!headline) return;

  const current = headline.textContent || '';
  if (applied.get(headline) === current) return;

  const updated = withDeliveryAdded(current, addCents);
  if (!updated || updated === current) return;

  headline.textContent = updated;
  applied.set(headline, updated);

  const button = root.querySelector('[data-target="coverage-button"]');
  const label = button?.getAttribute('aria-label');
  const updatedLabel = withDeliveryAdded(label, addCents);
  if (updatedLabel) button.setAttribute('aria-label', updatedLabel);
}

function patchAll() {
  document.querySelectorAll('redo-shopify-toggle').forEach(patchToggle);
}

const observed = new WeakSet();
const observer = new MutationObserver(() => schedule());

function observeShadowRoots() {
  document.querySelectorAll('redo-shopify-toggle').forEach((toggle) => {
    const root = toggle.shadowRoot;
    if (!root || observed.has(root)) return;
    observed.add(root);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  });
}

/* Coalesce bursts (Redo mounts its button across several mutations). */
let queued = false;
function schedule() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    observeShadowRoots();
    patchAll();
  });
}

observer.observe(document.body, { childList: true, subtree: true });
schedule();
document.addEventListener('cart:change', schedule);
document.addEventListener('cart-drawer:rendered', schedule);
